import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Observable, of } from 'rxjs';
import { TagComponentOptions } from '../tag.component';

@Component({
  selector: 'tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagListComponent implements OnInit {
  @Input() tags$: Observable<TagComponentOptions[]> | TagComponentOptions[];
  tagList$: Observable<TagComponentOptions[]>;
  @Input() collapsed: boolean = false;
  @Output() tagClicked = new EventEmitter<TagComponentOptions>();
  @Output() iconClicked = new EventEmitter<TagComponentOptions>();
  @Input() class: string = 'tag';

  ngOnInit() {
    this.class = this.collapsed ? 'lift-tag' : 'mr-1';
    this.tagList$ = !(this.tags$ instanceof Observable) ? of(this.tags$) : this.tags$;
  }

  onTagClicked(tag: TagComponentOptions) {
    this.tagClicked.emit(tag);
  }

  onIconClicked(tag: TagComponentOptions) {
    this.iconClicked.emit(tag);
  }

}
